import {
  JOBS_MANAGER_FETCHING,
  JOBS_MANAGER_FAILED,
  JOBS_MANAGER_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBS_MANAGER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBS_MANAGER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBS_MANAGER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
